"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableNames = void 0;
const getAvailableNames = props => {
    const { allNames = [], parameters = [] } = props;
    const availableNames = allNames.filter(name => parameters.length ? parameters.every(p => p.parameterName !== name) : true);
    return availableNames.length > 0 ? availableNames : null;
};
exports.getAvailableNames = getAvailableNames;
//# sourceMappingURL=utils.js.map